/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { GridQuery as a } from "./grid-query.mjs";
import { createTable as d, wrapTable as f } from "../common/utils.mjs";
const b = (c) => {
  const e = new a(c), o = e.content();
  let t;
  if (o) {
    const n = [o.querySelector("colgroup")], l = [e.header().querySelector("thead")], s = [o.querySelector("tbody")], r = e.footer(), u = r ? [r.querySelector("tfoot")] : [];
    t = d(n, l, s, u);
  } else
    t = f(e.table().cloneNode(!0));
  return t;
};
export {
  b as exportElement
};
